import * as yup from "yup";

import { type IRevAudForm } from "./RevAudCreate.types";
import type { ComboboxItem } from "@mantine/core";

export const revAudInitialValues: IRevAudForm = {
  emails: [],
  logbooks: [],
  revstart: "",
  revend: "",
  start: "",
  end: "",
  type: "",
  email: false,
};

export const mapSelectsData = (data: any) => {
  const emails: string[] = [];

  const users: ComboboxItem[] = [];

  data.data.content.data.users.forEach((u: any) => {
    if (!emails.includes(u.email)) {
      users.push({
        label: `${u.firstname} ${u.surname} - ${u.rolename}`,
        value: u.email,
      });
      emails.push(u.email);
    }
  });

  const logbooks = data.data.review.logbooks.map((log: any) => ({
    label: log.lbname,
    value: log.lbid,
  }));

  return { users, logbooks };
};

export const revAudValidationSchema = yup.object({
  emails: yup.array().required(),
  logbooks: yup.array().of(yup.string().required()).min(1).required(),
  revstart: yup.string().required(),
  revend: yup.string().required(),
  start: yup.string().required(),
  end: yup.string().required(),
  type: yup.string().required(),
  email: yup.boolean().required(),
});
